import React, { useState } from 'react';
export function QuoteForm() {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    // Simulate API call
    setTimeout(() => {
      setIsSubmitting(false);
      setIsSuccess(true);
      // Reset form after 3 seconds
      setTimeout(() => setIsSuccess(false), 3000);
    }, 1500);
  };
  if (isSuccess) {
    return <div className="bg-white p-8 rounded-xl shadow-lg border border-gray-100 text-center h-full flex flex-col items-center justify-center min-h-[400px]" data-id="element-339">
        <div className="w-16 h-16 bg-green-100 text-green-600 rounded-full flex items-center justify-center mb-4 mx-auto" data-id="element-340">
          <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-341">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-342" />
          </svg>
        </div>
        <h3 className="font-heading font-bold text-2xl text-brand-gray-dark mb-2" data-id="element-343">
          Quote Request Sent!
        </h3>
        <p className="font-body text-brand-gray" data-id="element-344">
          Thank you for reaching out. A member of our team will contact you
          shortly to discuss your project.
        </p>
      </div>;
  }
  return <div className="bg-white p-6 md:p-8 rounded-xl shadow-lg border border-gray-100" id="quote" data-id="element-345">
      <h3 className="font-heading font-bold text-2xl text-brand-gray-dark mb-6 text-center" data-id="element-346">
        Request a Free Quote
      </h3>
      <form onSubmit={handleSubmit} className="space-y-4 font-body" data-id="element-347">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-348">
          <div data-id="element-349">
            <label htmlFor="name" className="block text-sm font-medium text-brand-gray-dark mb-1" data-id="element-350">
              Full Name *
            </label>
            <input required type="text" id="name" className="w-full px-4 py-2.5 rounded-lg border border-gray-300 focus:ring-2 focus:ring-brand-blue focus:border-brand-blue outline-none transition-all" placeholder="John Doe" data-id="element-351" />
          </div>
          <div data-id="element-352">
            <label htmlFor="phone" className="block text-sm font-medium text-brand-gray-dark mb-1" data-id="element-353">
              Phone Number *
            </label>
            <input required type="tel" id="phone" className="w-full px-4 py-2.5 rounded-lg border border-gray-300 focus:ring-2 focus:ring-brand-blue focus:border-brand-blue outline-none transition-all" placeholder="(586) 555-0123" data-id="element-354" />
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-355">
          <div data-id="element-356">
            <label htmlFor="email" className="block text-sm font-medium text-brand-gray-dark mb-1" data-id="element-357">
              Email Address
            </label>
            <input type="email" id="email" className="w-full px-4 py-2.5 rounded-lg border border-gray-300 focus:ring-2 focus:ring-brand-blue focus:border-brand-blue outline-none transition-all" placeholder="john@example.com" data-id="element-358" />
          </div>
          <div data-id="element-359">
            <label htmlFor="city" className="block text-sm font-medium text-brand-gray-dark mb-1" data-id="element-360">
              City *
            </label>
            <input required type="text" id="city" className="w-full px-4 py-2.5 rounded-lg border border-gray-300 focus:ring-2 focus:ring-brand-blue focus:border-brand-blue outline-none transition-all" placeholder="Harrison Township" data-id="element-361" />
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-362">
          <div data-id="element-363">
            <label htmlFor="service" className="block text-sm font-medium text-brand-gray-dark mb-1" data-id="element-364">
              Service Needed *
            </label>
            <select required id="service" className="w-full px-4 py-2.5 rounded-lg border border-gray-300 focus:ring-2 focus:ring-brand-blue focus:border-brand-blue outline-none transition-all bg-white" data-id="element-365">
              <option value="" data-id="element-366">Select a service...</option>
              <option value="roofing" data-id="element-367">Roofing & Repairs</option>
              <option value="gutters" data-id="element-368">Gutter Services</option>
              <option value="siding" data-id="element-369">Siding</option>
              <option value="windows" data-id="element-370">Windows</option>
              <option value="painting" data-id="element-371">Painting</option>
              <option value="commercial" data-id="element-372">Commercial Roofing</option>
              <option value="storm" data-id="element-373">Storm Damage</option>
              <option value="other" data-id="element-374">Other</option>
            </select>
          </div>
          <div data-id="element-375">
            <label htmlFor="time" className="block text-sm font-medium text-brand-gray-dark mb-1" data-id="element-376">
              Preferred Contact Time
            </label>
            <select id="time" className="w-full px-4 py-2.5 rounded-lg border border-gray-300 focus:ring-2 focus:ring-brand-blue focus:border-brand-blue outline-none transition-all bg-white" data-id="element-377">
              <option value="any" data-id="element-378">Any Time</option>
              <option value="morning" data-id="element-379">Morning (8am - 12pm)</option>
              <option value="afternoon" data-id="element-380">Afternoon (12pm - 4pm)</option>
              <option value="evening" data-id="element-381">Evening (4pm - 7pm)</option>
            </select>
          </div>
        </div>

        <div data-id="element-382">
          <label htmlFor="message" className="block text-sm font-medium text-brand-gray-dark mb-1" data-id="element-383">
            Project Details
          </label>
          <textarea id="message" rows={3} className="w-full px-4 py-2.5 rounded-lg border border-gray-300 focus:ring-2 focus:ring-brand-blue focus:border-brand-blue outline-none transition-all resize-none" placeholder="Tell us a bit about what you need help with..." data-id="element-384"></textarea>
        </div>

        <button type="submit" disabled={isSubmitting} className="w-full bg-brand-blue hover:bg-brand-blue-dark text-white font-bold py-3.5 rounded-lg transition-colors flex items-center justify-center gap-2 disabled:opacity-70" data-id="element-385">
          {isSubmitting ? 'Sending Request...' : 'Get Your Free Quote'}
        </button>

        <p className="text-xs text-center text-brand-gray mt-2" data-id="element-386">
          By submitting this form, you agree to be contacted by Moceri
          Residential Services.
        </p>
      </form>
    </div>;
}